jQuery(document).ready(function ($) {
  const loadOptions = (selector, data, selectedValue = null) => {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: ajaxData.ajaxurl,
        method: "POST",
        data: data,
        success: function (response) {
          if (response.trim().length > 0) {
            $(selector)
              .html('<option value="">Seleccione una opción</option>') // Agregar opción inicial
              .append(response.trim()) // Añadir opciones recibidas
              .prop("hidden", false)
              .css("display", "inline-block");

            if (selectedValue) {
              $(selector).val(selectedValue); // Mantener el valor seleccionado
            }
          } else {
            $(selector)
              .html('<option value="">No hay opciones disponibles</option>')
              .prop("hidden", true)
              .css("display", "none");
          }
          resolve(); // Resolución exitosa
        },
        error: function (xhr, status, error) {
          console.error("Error en la solicitud AJAX:", error);
          reject(error); // Rechazo en caso de error
        },
      });
    });
  };

  const initializeSelectors = async () => {
    // Obtener valores iniciales desde los atributos `data-selected`
    const parentIDN1 = $("#select-ambito-n1").val();
    const initialCategoryN2 = $("#select-estudio-n2").data("selected");
    const initialCategoryN3 = $("#select-termino-n3").data("selected");

    const promises = [];

    // Cargar Nivel 2 si Nivel 1 tiene un valor
    if (parentIDN1) {
      promises.push(
        loadOptions(
          "#select-estudio-n2",
          { action: "get_child_categories", parent_id: parentIDN1 },
          initialCategoryN2
        )
      );
    }

    // Cargar Nivel 3 si Nivel 2 tiene un valor inicial
    if (initialCategoryN2) {
      promises.push(
        loadOptions(
          "#select-termino-n3",
          { action: "get_child_categories", parent_id: initialCategoryN2 },
          initialCategoryN3
        )
      );
    }

    // Ejecutar todas las solicitudes en paralelo
    try {
      await Promise.all(promises);
      //console.log("Selectores inicializados correctamente");
    } catch (error) {
      console.error("Error inicializando los selectores:", error);
    }
  };

  // Inicializar al cargar la página
  initializeSelectors();

  // Eventos de cambio para cargar dinámicamente los selectores inferiores
  $("#select-ambito-n1").change(function () {
    const parentID = $(this).val();
    if (parentID) {
      loadOptions("#select-estudio-n2", { action: "get_child_categories", parent_id: parentID });
      $("#select-termino-n3").prop("hidden", true).css("display", "none").val("");
    } else {
      $("#select-estudio-n2, #select-termino-n3").prop("hidden", true).css("display", "none").val("");
    }
  });

  $("#select-estudio-n2").change(function () {
    const parentID = $(this).val();
    if (parentID) {
      loadOptions("#select-termino-n3", { action: "get_child_categories", parent_id: parentID });
    } else {
      $("#select-termino-n3").prop("hidden", true).css("display", "none").val("");
    }
  });
});
